<template>
  <div class="chatbot-dialog">
    <el-dialog
      title="温馨提示"
      :visible="isDialogVisible"
      :before-close="handleCloseDialog"
    >
      <p>
        如您遇到关于<b>三诺血糖仪</b>使用、操作等问题，可拨打三诺全国客服热线
        <a class="red" href="tel:400-887-0036">400-887-0036 </a>
      </p>
      <p>
        如果您有礼来公司产品的问题例如：<b>优泌乐</b>和<b>优伴笔</b>相关的产品问题，可以在非法定节假日9:00-18:00咨询礼来客服中心热线
        <a class="red" href="tel:400-820-5078">400-820-5078</a>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-btn" @click="handleCloseDialog">
          好 的
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ChatbotDialog",
  data() {
    // console.log(this);
    return {
      isDialogVisible: this.initialDialogVisible,
    };
  },
  watch: {
    initialDialogVisible: function (val) {
      this.isDialogVisible = val;
    },
  },
  methods: {
    handleCloseDialog: function () {
      this.isDialogVisible = false;
      this.$emit("sendDialogActionValue", this.isDialogVisible);
    },
  },
  props: {
    initialDialogVisible: Boolean,
  },
};
</script>

<style lang="scss">
.chatbot-dialog {
  text-align: center;
  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 1px 3pxrgba (0, 0, 0, 0.3);
    box-sizing: border-box;
    width: 80% !important;
  }
  .el-dialog__body {
    padding: 0px 20px !important;
    color: #606266;
    word-break: break-all;
    font-size: 16px;
  }
  .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;
    box-sizing: border-box;
    text-align: center;
  }
}
.chatbot-dialog p {
  line-height: 32px;
  text-align: left;
  text-align: justify;
}

.chatbot-dialog b {
  font-weight: 900;
  color: black;
}

.chatbot-dialog p span {
  padding: 0px 5px;
}
.dialog-footer {
  margin-top: 15px;
  text-align: center !important;
}
.dialog-btn {
  background-color: #d72618;
  color: #fff;
  width: 90px;
  border-radius: 25px;
}
.red {
  color: #d72618;
}
</style>
